import { Input, Col, Row, Space } from "antd";
import { useState, useCallback, useEffect } from "react";

interface WarehouseStateControlsProps {
  onApply: (
    position: string,
    pallet: string,
    corridor: string,
    column: string,
    level: string
  ) => void;
}

const WarehouseStateControls = (props: WarehouseStateControlsProps) => {
  const [position, setPosition] = useState<string>("");
  const [pallet, setPallet] = useState<string>("");
  const [corridor, setCorridor] = useState<string>("");
  const [column, setColumn] = useState<string>("");
  const [level, setLevel] = useState<string>("");

  const onApply = useCallback(() => {
    props.onApply(position, pallet, corridor, column, level);
  }, [props, position, pallet, corridor, column, level]);

  useEffect(() => {
    onApply();
  }, [onApply]);

  return (
    <Row gutter={20}>
      <Col>
        <Space>
          Position
          <Input
            placeholder="Position"
            value={position}
            onChange={(e) => setPosition(e.target.value)}
          />
        </Space>
      </Col>
      <Col>
        <Space>
          Pallet
          <Input
            placeholder="Pallet"
            value={pallet}
            onChange={(e) => setPallet(e.target.value)}
          />
        </Space>
      </Col>
      <Col>
        <Space>
          Corridor
          <Input
            placeholder="Corridor"
            value={corridor}
            onChange={(e) => setCorridor(e.target.value)}
          />
        </Space>
      </Col>
      <Col>
        <Space>
          Column
          <Input
            placeholder="Column"
            value={column}
            onChange={(e) => setColumn(e.target.value)}
          />
        </Space>
      </Col>
      <Col>
        <Space>
          Level
          <Input
            placeholder="Level"
            value={level}
            onChange={(e) => setLevel(e.target.value)}
          />
        </Space>
      </Col>
    </Row>
  );
};

export default WarehouseStateControls;
